var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.3C0.834315 9.3 0.7 9.16568 0.7 9V1C0.7 0.834315 0.834315 0.7 1 0.7H7C7.16569 0.7 7.3 0.834315 7.3 1V9C7.3 9.16569 7.16569 9.3 7 9.3H1ZM1 17.3C0.834314 17.3 0.7 17.1657 0.7 17V13C0.7 12.8343 0.834315 12.7 1 12.7H7C7.16568 12.7 7.3 12.8343 7.3 13V17C7.3 17.1657 7.16569 17.3 7 17.3H1ZM11 17.3C10.8343 17.3 10.7 17.1657 10.7 17V9C10.7 8.83431 10.8343 8.7 11 8.7H17C17.1657 8.7 17.3 8.83431 17.3 9V17C17.3 17.1657 17.1657 17.3 17 17.3H11ZM10.7 1C10.7 0.834314 10.8343 0.7 11 0.7H17C17.1657 0.7 17.3 0.834314 17.3 1V5C17.3 5.16569 17.1657 5.3 17 5.3H11C10.8343 5.3 10.7 5.16569 10.7 5V1Z",
    stroke: "#757575",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.d99b86ca.svg";
export { ForwardRef as ReactComponent };